// extracted by mini-css-extract-plugin
export default {"root":"YYaQ-","large":"hk-Vw","hoverable":"_1sR0G","medium":"tORuE","small":"_1J8FA"};